import React from 'react';
import { Box } from '@mui/material';
import { useThemeContext } from '../../hook/useThemeManager';
import { theme } from '../../constants/theme';

interface CommentElbowConnectorProps {
    verticalOffset: number; // vertical distance from parent avatar bottom to reply avatar center
    horizontalOffset?: number; // horizontal distance from parent avatar center to reply avatar left, default 32px
    animate?: boolean;
}

export const CommentCurvedConnector: React.FC<CommentElbowConnectorProps> = ({
    verticalOffset,
    horizontalOffset = 32,
    animate = true,
}) => {
    const { themeStyle } = useThemeContext();
    const avatarSize = 32;
    const radius = 8; // Curve radius

    // Start at center bottom of parent avatar
    const startX = avatarSize / 2;
    const startY = avatarSize;

    // End at left center of reply avatar
    const endX = horizontalOffset;
    const endY = avatarSize + verticalOffset;

    // Calculate the curve points
    const verticalLength = endY - startY - radius;
    // const horizontalLength = endX - startX - radius;

    // Create the path: down, curve right, then right to avatar
    const path = `
        M${startX},${startY}
        L${startX},${startY + verticalLength}
        Q${startX},${startY + verticalLength + radius} ${startX + radius},${startY + verticalLength + radius}
        L${endX},${endY}
    `;

    const svgWidth = Math.max(endX + 10, avatarSize);
    const svgHeight = Math.max(endY + 10, avatarSize);

    return (
        <Box
            sx={{
                position: 'absolute',
                left: 0,
                top: 0,
                pointerEvents: 'none',
                zIndex: 0,
                width: svgWidth,
                height: svgHeight,
            }}>
            <svg width={svgWidth} height={svgHeight} style={{ display: 'block', overflow: 'visible' }}>
                <path
                    d={path}
                    stroke={theme[themeStyle].tag_white}
                    strokeWidth={1}
                    fill="none"
                    opacity={0.5}
                    style={animate ? { transition: 'd 0.3s cubic-bezier(0.4,0,0.2,1)' } : {}}
                />
            </svg>
        </Box>
    );
};
